import React from 'react';
import querystring from 'querystring';

import {CONTACT_EMAIL} from 'app/const';
import Block from 'ui/block';
import {AnchorButton} from 'ui/button';


export default function ContactCtaBlock({emailSubject, emailBody}) {

    const _query = querystring.stringify({
        subject: emailSubject,
        body: emailBody,
    });

    const href = `mailto:${CONTACT_EMAIL}?${_query}`;

    return <Block style={{textAlign: 'center'}}>
        <div style={{fontSize: '1.2em'}}>
            <AnchorButton href={href} target="_blank" theme="accent" size="large">
                Get in touch now
            </AnchorButton>
        </div>
        <div style={{marginTop:'.5em'}}>
            <a href={href} target="_blank">
                {CONTACT_EMAIL}
            </a>
        </div>
    </Block>;
};



// WEBPACK FOOTER //
// ./src/components/contact-cta-block.js